
import {
  HttpClient, HttpParams
} from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { Sustitucion } from '../models/sustitucion.model';
import { DatosSustitucionesKpiModel } from '../models/datosSustitucionesKpi.model';


@Injectable()
export class SustitucionService extends HttpClientBaseService implements IServiceBase<Sustitucion> {
  constructor(_http: HttpClient) {
    super(_http, 'Sustituciones/','', false);
  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<Sustitucion>> {
    throw new Error('Method not implemented.');
  }

  public getAllModels(): Observable<Sustitucion[]> {
    return super.getAll<Sustitucion[]>();
  }

  public getKpiDataByCompany(companyCode: any, year: number): Observable<DatosSustitucionesKpiModel> {
    const url = `${super.getConcatUrl()}empresa/${companyCode}/ejercicio/${year}/datosKpi`;
    return super.get<DatosSustitucionesKpiModel>(url);
  }

  public getAllModelsByCompany(companyCode: any, year: number, sustitucionesCerradas: boolean): Observable<Sustitucion[]> {
    const url = `${super.getConcatUrl()}Empresa/${companyCode}/ejercicio/${year}/${sustitucionesCerradas}`;
    return super.get<Sustitucion[]>(url);
  }

  public getModel(id: any): Observable<Sustitucion> {
    return super.getSingle<Sustitucion>(id);
  }


}
